import { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import { Alert, Box, Paper, Stack } from "@mui/material"

import useInternalFetch 	from "../../api/apiInternal"

import SubscriptionList 	from "./components/SubscriptionList"
import SubscriptionForm 	from "./components/SubscriptionForm"
import Subscribe 			from "./views/Subscribe"
import Loading from "../../components/Loading"
import CreditCardForm from "./components/CreditCardForm"
import config from "../../common/Config"

const Subscription = () => {

	const location									= useLocation()

	const {subscriptionId}							= useParams()
	const [subscriptions, setSubscriptions]			= useState()
	const [isLoading, setIsLoading]					= useState(true)
	const [returnMessage, setReturnMessage]			= useState()

	const internalFetch								= useInternalFetch()

	useEffect(() => {
		if (!subscriptionId) {
			loadSubscriptions()
		}
		else {
			setIsLoading(false)
		}

	}, [])

	useEffect(() => {
		setReturnMessage(location.state?.returnMessage || null)
		window.history.replaceState({}, '')
		if (!subscriptionId) loadSubscriptions()
	}, [location.state])

	const loadSubscriptions = () => {
		setIsLoading(true)

		internalFetch(config.apiUrl +'/subscription')
		.then(results => {
			setSubscriptions(results.data)
			setIsLoading(false)
		})
	}
	
	if (isLoading) return <Loading />

	return (
		<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, height:'88vh', display: 'flex', justifyContent: 'center' }} elevation={1}>
			<Box justifyContent={'center'} sx={{width: {xs: '100%', sm: '90%', md: '80%'}, overflowX: 'auto'}}>
				<Stack direction={'column'} display='flex' justifyContent={'center'}>
					{ returnMessage ? (
						<Alert severity='success' sx={{m: 1}} onClose={() => setReturnMessage(null)}>{returnMessage}</Alert>
					) : null}
					
					{ !subscriptionId ? (
						subscriptions?.length > 0 ? (
							<SubscriptionList />
						) : (
							<Subscribe />
						)
					) : (
						subscriptionId === 'new' ? (
							<SubscriptionForm />
						) : (
							<CreditCardForm subscriptionId={subscriptionId}/>
						)
					)}
				</Stack>
			</Box>
		</Paper>
	)
}

export default Subscription